import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const DayBookStyledExport = () => {

  const data = {
    "success": true,
    "message": "Day Book fetched successfully",
    "headers": [
        "Date",
        "Roll Number",
        "Student Name",
        "Father Name",
        "Class Name",
        "Section Name",
        "Payment Mode",
        "bank Name",
        "Cheque No",
        "Academic Fees",
        "Registration Fees",
        "Other Fees",
        "Transport Fee",
        "hostel Fee",
        "Fine",
        "Total",
        "User Name",
        "Enter Date"
    ],
    "data": [
        {
            "date": "2026-03-14",
            "rollNumber": null,
            "studentName": "Tanvi  Agarwal",
            "fatherName": "Jatin Pandey",
            "className": "1",
            "sectionName": "C",
            "payment_mode": "cash",
            "bankName": null,
            "chequeNo": null,
            "academicFees": 2000,
            "registrationFees": 100,
            "otherFees": 0,
            "transport_fee": 0,
            "hostel_fee": 0,
            "fine": 0,
            "total": 2100,
            "entry_date": "2026-03-14T04:42:08.000000Z",
            "userName": "Vice Principal"
        },
        {
            "date": "2026-04-15",
            "rollNumber": null,
            "studentName": "Rama k Kumar",
            "fatherName": "abc kumar",
            "className": "1",
            "sectionName": "C",
            "payment_mode": "cash",
            "bankName": null,
            "chequeNo": null,
            "academicFees": 0,
            "registrationFees": 1000,
            "otherFees": 0,
            "transport_fee": 0,
            "hostel_fee": 0,
            "fine": 10,
            "total": 990,
            "entry_date": "2026-04-28T08:37:19.000000Z",
            "userName": "Vice Principal"
        },
        {
            "date": "2026-04-25",
            "rollNumber": null,
            "studentName": "Rama k Kumar",
            "fatherName": "abc kumar",
            "className": "1",
            "sectionName": "C",
            "payment_mode": "cash",
            "bankName": null,
            "chequeNo": null,
            "academicFees": 4500,
            "registrationFees": 1000,
            "otherFees": 0,
            "transport_fee": 8000,
            "hostel_fee": 0,
            "fine": 5810,
            "total": 7690,
            "entry_date": "2026-04-25T08:47:39.000000Z",
            "userName": "Vice Principal"
        },
        {
            "date": "2026-04-25",
            "rollNumber": null,
            "studentName": "Ishika  Choudhary",
            "fatherName": "Jatin Ansari",
            "className": "1",
            "sectionName": "C",
            "payment_mode": "cash",
            "bankName": null,
            "chequeNo": null,
            "academicFees": 7000,
            "registrationFees": 2000,
            "otherFees": 0,
            "transport_fee": 0,
            "hostel_fee": 0,
            "fine": 10,
            "total": 8990,
            "entry_date": "2026-04-25T10:01:03.000000Z",
            "userName": "Vice Principal"
        },
        {
            "date": "2026-04-28",
            "rollNumber": null,
            "studentName": "Rama k Kumar",
            "fatherName": "abc kumar",
            "className": "1",
            "sectionName": "C",
            "payment_mode": "cash",
            "bankName": null,
            "chequeNo": null,
            "academicFees": 0,
            "registrationFees": 2000,
            "otherFees": 0,
            "transport_fee": 4000,
            "hostel_fee": 0,
            "fine": 820,
            "total": 5180,
            "entry_date": "2026-04-28T08:38:44.000000Z",
            "userName": "Vice Principal"
        }
    ],
    "schoolDetails": {
        "id": 4,
        "name": "Principal",
        "designation": null,
        "phone": "9867514551",
        "email": "principal@gmail.com",
        "website": null,
        "logo": null,
        "status": 1,
        "city": "Kanpur",
        "state": "Up",
        "pincode": 208001,
        "school_name": "Ace School",
        "associated_user_id": 2,
        "url": null,
        "isdeploy": 0,
        "created_at": "2026-04-21T09:59:09.000000Z",
        "updated_at": "2026-04-21T15:40:19.000000Z"
    }
}; 

  const sortedData = [...data.data].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const rows = [];
  let currentDate = null;

  let daily = initTotals();
  let grand = initTotals();

  sortedData.forEach((item) => {

    if (currentDate !== item.date) {

      if (currentDate !== null) {
        rows.push({ type: "daily", ...daily });
        daily = initTotals();
      }

      currentDate = item.date;
    }

    rows.push({ type: "data", ...item });

    addTotals(daily, item);
    addTotals(grand, item);
  });

  rows.push({ type: "daily", ...daily });
  rows.push({ type: "grand", ...grand });

  function initTotals() {
    return {
      academicFees: 0,
      registrationFees: 0,
      otherFees: 0,
      transport_fee: 0,
      hostel_fee: 0,
      fine: 0,
      total: 0
    };
  }

  function addTotals(obj, item) {
    obj.academicFees += item.academicFees;
    obj.registrationFees += item.registrationFees;
    obj.otherFees += item.otherFees;
    obj.transport_fee += item.transport_fee;
    obj.hostel_fee += item.hostel_fee;
    obj.fine += item.fine;
    obj.total += item.total;
  }

  const downloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Day Book");

    sheet.addRow([data.schoolDetails.school_name]);
    sheet.addRow([]);

    sheet.addRow(data.headers);

    rows.forEach(r => {
      if (r.type === "data") {
        sheet.addRow([
          r.date,
          r.rollNumber || "-",
          r.studentName,
          r.fatherName,
          r.className,
          r.sectionName,
          r.payment_mode,
          r.bankName || "-",
          r.chequeNo || "-",
          r.academicFees,
          r.registrationFees,
          r.otherFees,
          r.transport_fee,
          r.hostel_fee,
          r.fine,
          r.total,
          r.userName,
          r.entry_date
        ]);
      }

      if (r.type === "daily") {
        const row = sheet.addRow([
          "", "Daily Total", "", "", "", "", "", "", "",
          r.academicFees,
          r.registrationFees,
          r.otherFees,
          r.transport_fee,
          r.hostel_fee,
          r.fine,
          r.total
        ]);

        row.eachCell(cell => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFDAEEF3" }
          };
        });
      }

      if (r.type === "grand") {
        const row = sheet.addRow([
          "", "Grand Total", "", "", "", "", "", "", "",
          r.academicFees,
          r.registrationFees,
          r.otherFees,
          r.transport_fee,
          r.hostel_fee,
          r.fine,
          r.total
        ]);

        row.eachCell(cell => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFBDD7EE" } 
          };
        });

        row.font = { bold: true };
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "DayBook.xlsx");
  };

  return (
    <div style={{ padding: 20 }}>
         <button
        onClick={downloadExcel}
        style={{
          marginBottom: 15,
          padding: "8px 16px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          cursor: "pointer"
        }}
      >
        Download Excel
      </button>
      <h2 style={{ textAlign: "center" }}>
        {data.schoolDetails.school_name}
      </h2>

      <div style={{ marginBottom: 10 }}>
        <b>
          Payment Date: {sortedData[0]?.date} to {sortedData[sortedData.length - 1]?.date}
        </b><br/>
        User: All <br/>
        Class: All, Section: All <br/>
        Payment Mode: All
      </div>

      <h3 style={{ textAlign: "center" }}>Day Book Report</h3>

      <table border="1" cellPadding="5" style={{ width: "100%" }}>
        <thead>
          <tr>
            {data.headers.map((h, i) => (
              <th key={i} style={{ fontSize: "12px" }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((r, i) => {

            if (r.type === "data") {
              return (
                <tr key={i} style={{fontSize:"11px"}}>
                  <td>{r.date}</td>
                  <td>{r.rollNumber || "-"}</td>
                  <td>{r.studentName}</td>
                  <td>{r.fatherName}</td>
                  <td>{r.className}</td>
                  <td>{r.sectionName}</td>
                  <td>{r.payment_mode}</td>
                  <td>{r.bankName || "-"}</td>
                  <td>{r.chequeNo || "-"}</td>
                  <td>{r.academicFees}</td>
                  <td>{r.registrationFees}</td>
                  <td>{r.otherFees}</td>
                  <td>{r.transport_fee}</td>
                  <td>{r.hostel_fee}</td>
                  <td>{r.fine}</td>
                  <td>{r.total}</td>
                  <td>{r.userName}</td>
                  <td>{r.entry_date}</td>
                </tr>
              );
            }

            if (r.type === "daily") {
              return (
                <tr key={i} style={{ background: "#DAEEF3", fontWeight: "bold" ,fontSize:"11px"}}>
                  <td></td>
                  <td>Daily Total</td>
                  <td colSpan="7"></td>
                  <td>{r.academicFees}</td>
                  <td>{r.registrationFees}</td>
                  <td>{r.otherFees}</td>
                  <td>{r.transport_fee}</td>
                  <td>{r.hostel_fee}</td>
                  <td>{r.fine}</td>
                  <td>{r.total}</td>
                  <td colSpan="2"></td>
                </tr>
              );
            }

            if (r.type === "grand") {
              return (
                <tr key={i} style={{ background: "#BDD7EE", fontWeight: "bold" ,fontSize:"11px"}}>
                  <td></td>
                  <td>Grand Total</td>
                  <td colSpan="7"></td>
                  <td>{r.academicFees}</td>
                  <td>{r.registrationFees}</td>
                  <td>{r.otherFees}</td>
                  <td>{r.transport_fee}</td>
                  <td>{r.hostel_fee}</td>
                  <td>{r.fine}</td>
                  <td>{r.total}</td>
                  <td colSpan="2"></td>
                </tr>
              );
            }

            return null;
          })}
        </tbody>
      </table>

    </div>
  );
};

export default DayBookStyledExport;